import ChairHeart from '../../src/legacy/ChairHeart.tsx';
export default ChairHeart;
